import { Injectable, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export abstract class Unsuscribe implements OnDestroy {
    destroy: Subject<void> = new Subject<void>();

    ngOnDestroy(): void {
        this.destroy.next();
        this.destroy.complete();
    }

}